import { useAutocompleteSource } from '@eas/common-web';
import { DocumentAutocomplete } from '@models';
import { EvidenceApiUrl } from '@enums';

export function useDocuments() {
  return useAutocompleteSource<DocumentAutocomplete>({
    url: `${EvidenceApiUrl.DOCUMENT}/autocomplete`,
  });
}
